import { API_BASE_URL } from "../utils/ApiUrls";

class ExportService {

  async exportRisksPDF(accessToken, filters = {}) {
    console.log('📡 Exporting risks PDF:', filters);
    
    try {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key]) params.append(key, filters[key]);
      });
      const queryString = params.toString();
      
      const response = await fetch(`${API_BASE_URL}/api/cartopousse/export-risks-pdf/${queryString ? `?${queryString}` : ''}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        const filename = `risques_export_${new Date().toISOString().split('T')[0]}.pdf`;
        
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        return {
          success: true,
          status: response.status,
          message: 'Export PDF réussi'
        };
      } else {
        const errorData = await response.json().catch(() => ({}));
        return {
          success: false,
          status: response.status,
          error: errorData.detail || 'Erreur lors de l\'export PDF',
          errorData
        };
      }
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: 'Erreur de connexion'
      };
    }
  }

  async exportProcessesPDF(accessToken, filters = {}) {
    console.log('📡 Exporting processes PDF:', filters);
    
    try {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key]) params.append(key, filters[key]);
      });
      const queryString = params.toString();
      
      const response = await fetch(`${API_BASE_URL}/api/cartopousse/export-processes-pdf/${queryString ? `?${queryString}` : ''}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        const filename = `processus_export_${new Date().toISOString().split('T')[0]}.pdf`;
        
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        return {
          success: true,
          status: response.status,
          message: 'Export PDF réussi'
        };
      } else {
        const errorData = await response.json().catch(() => ({}));
        return {
          success: false,
          status: response.status,
          error: errorData.detail || 'Erreur lors de l\'export PDF',
          errorData
        };
      }
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: 'Erreur de connexion'
      };
    }
  }

  async exportRisksExcel(accessToken, filters = {}) {
    console.log('📡 Exporting risks Excel:', filters);
    
    try {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key]) params.append(key, filters[key]);
      });
      const queryString = params.toString();
      
      const response = await fetch(`${API_BASE_URL}/api/cartopousse/export-risks-excel/${queryString ? `?${queryString}` : ''}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        const filename = `risques_export_${new Date().toISOString().split('T')[0]}.xlsx`;
        
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        return {
          success: true,
          status: response.status,
          message: 'Export Excel réussi'
        };
      } else {
        const errorData = await response.json().catch(() => ({}));
        return {
          success: false,
          status: response.status,
          error: errorData.detail || 'Erreur lors de l\'export Excel',
          errorData
        };
      }
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: 'Erreur de connexion'
      };
    }
  }

  async exportProcessesExcel(accessToken, filters = {}) {
    console.log('📡 Exporting processes Excel:', filters);
    
    try {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key]) params.append(key, filters[key]);
      });
      const queryString = params.toString();
      
      const response = await fetch(`${API_BASE_URL}/api/cartopousse/export-processes-excel/${queryString ? `?${queryString}` : ''}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        const filename = `processus_export_${new Date().toISOString().split('T')[0]}.xlsx`;
        
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        return {
          success: true,
          status: response.status,
          message: 'Export Excel réussi'
        };
      } else {
        const errorData = await response.json().catch(() => ({}));
        return {
          success: false,
          status: response.status,
          error: errorData.detail || 'Erreur lors de l\'export Excel',
          errorData
        };
      }
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: 'Erreur de connexion'
      };
    }
  }
}

const exportService = new ExportService();
export default exportService;